import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { AlertTriangle } from 'lucide-react';

/**
 * Global banner that displays when Demo Pilot Mode is active.
 * Renders at the top of admin and customer layouts.
 * Production GO/NO-GO gate: this must NOT be visible in production.
 */
export function DemoModeBanner() {
  const [demoActive, setDemoActive] = useState(false);

  useEffect(() => {
    const check = async () => {
      const { data } = await supabase
        .from('demo_settings' as any)
        .select('enabled')
        .limit(1)
        .maybeSingle();
      setDemoActive((data as any)?.enabled === true);
    };
    check();

    // Re-check every 30s
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!demoActive) return null;

  return (
    <div className="bg-amber-500 text-amber-950 text-center py-1.5 px-4 text-sm font-semibold flex items-center justify-center gap-2 z-50">
      <AlertTriangle className="w-4 h-4" />
      DEMO PILOT MODE — Not for production use
      <AlertTriangle className="w-4 h-4" />
    </div>
  );
}
